export default __webpack_public_path__ + "static/media/number_2.2be8b046.svg";